import AbstractListResource from './abstract/abstract-list-resource';
import {Resource, ActionType, EpgActionType, Uid}  from 'sdk/src/defines';
import State from './items/state';
import {DispatchFunc, DispatchResponse} from '../utility/types';
import contents from './contents';
import Content from './items/content';

class States extends AbstractListResource<State> {
    public resourceType: Resource = Resource.STATES;

    public resourceItemClass: typeof State = State;

    public allowedActions: ActionType[] = [
        ActionType.LIST,
    ];

    public onUpdated(items: State[]): DispatchResponse {
        return (dispatch: DispatchFunc) => {
            items.forEach((item: State)=> {
                if (item.type === Resource.EPGS && item.state.actionType === EpgActionType.EPG_PARSED) {
                    if (item.state.channelId) {
                        dispatch(contents.update({}, item.state.channelId));
                    } else {
                        const ids: Uid[] = [];

                        contents.getItems().forEach((content: Content) => {
                            if (content.props?.epg?.url && content.props?.epg?.id) {
                                ids.push(content.id);
                            }
                        });

                        dispatch(contents.update({}, ids));
                    }
                }
            });

            return super.onUpdated(items);
        };
    }

    public getItemByOperatorId(operatorId: Uid): State {
        return this.getItems().find((item: State) => item.operatorId === operatorId);
    }
}

export {States, State};
export default new States();